module.exports = __webpack_public_path__ + "img/netherlands-logo-icon.2a776be8.png";